import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import configModel from 'src/assets/config.json';
import { environment } from 'src/environments/environment';
import { PermissionService } from './permission.service';
import { TourService } from './tour.service';

export enum Company {
  DEBRAIN,
  M3M,
  NOT_DEFINED
}

export interface SystemConfig {
  expiringTimeRenewal: number | null;
  canRenewExpiredBook: boolean;
  prpSlave: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  _systemConfig: SystemConfig | undefined;
  get systemConfig(): Promise<SystemConfig> {
    return new Promise<SystemConfig>((resolve, reject) => {
      if (this._systemConfig == null) {
        setTimeout(() => {
          this.systemConfig.then(res => {
            resolve(res)
          }).catch(err => reject(err))
        }, 200);
      } else {
        resolve(this._systemConfig);
      }
    })
  }


  private get isPageSmall() {
    return window.innerWidth <= 991;
  }

  get BOOK_URL() {
    return new Promise<string>((resolve, reject) => {
      this.getConfig().then(c => {
        const protocol = (c.protocol != null) ? c.protocol : (location.protocol + '//')
        const hostname = (c.ip != null) ? c.ip : location.hostname
        const port = (c.port != null) ? c.port : location.port
        const storageHref = environment.storageHref != null ? `/${environment.storageHref}` : ''
        resolve(`${protocol}${hostname}:${port}${storageHref}`);
      })
    })
  }

  get surrounding_images() {
    return new Promise<number>((resolve, reject) => {
      this.getConfig().then(c => {
        resolve((this.isPageSmall) ? c.simple_viewer_surrounding_images_mobile : c.simple_viewer_surrounding_images_pc);
      })
    })
  }

  /** USAR SOLO SI ESTÁS SEGURO DE QUE SE HA CARGADO LA CONFIGURACIÓN */
  get syncBOOK_URL() {
    const protocol = (this.config.protocol != null) ? this.config.protocol : (location.protocol + '//')
    const hostname = (this.config.ip != null) ? this.config.ip : location.hostname
    const port = (this.config.port != null) ? this.config.port : location.port
    const storageHref = environment.storageHref != null ? `/${environment.storageHref}` : ''
    return (`${protocol}${hostname}:${port}${storageHref}`);
  }

  /** USAR SOLO SI ESTÁS SEGURO DE QUE SE HA CARGADO LA CONFIGURACIÓN */
  get config() {
    return this._config;
  }

  private _jsonURL = 'assets/config.json';
  private _config: typeof configModel;

  private gettingConfig = false;

  get company(): Company {
    switch (this._config?.company) {
      case 'DEBRAIN':
      case 'debrain':
      case 'deBrain':
      case 'DeBrain':
        return Company.DEBRAIN;
      case 'M3M':
      case 'm3m':
      case 'm3mEuropa':
      case 'M3MEUROPA':
        return Company.M3M;
    }
    return Company.NOT_DEFINED;
  }

  constructor(
    private http: HttpClient,
    private permissionService: PermissionService,
    private tourService: TourService
  ) {
    this.getConfig();
    if (!environment.demo) {
      this.getSystemConfig().then(res => {
        this._systemConfig = {
          expiringTimeRenewal: (res.expiringTimeRenewal != null) ? +res.expiringTimeRenewal : null,
          canRenewExpiredBook: (res.canRenewExpiredBook != null) ? res.canRenewExpiredBook : false,
          prpSlave: (res.prpSlave != null) ? res.prpSlave : false
        }
        console.log('this._systemConfig', this._systemConfig);

      }).catch(err => {
        console.error('Error obteniendo system config')
      })
    }
  }

  public getConfig(): Promise<typeof configModel> {
    return new Promise((resolve, reject) => {
      if (this._config != null) {
        resolve(this._config);
      } else {
        if (this.gettingConfig) {
          setTimeout(() => {
            this.getConfig().then(c => resolve(c));
          }, 50);
        } else {
          this.gettingConfig = true;
          this.http.get<typeof configModel>(this._jsonURL).subscribe(c => {
            this._config = c;
            const visorProtocol = (c.protocolVisor != null) ? c.protocolVisor : (location.protocol + '//')
            const visorHostname = (c.ipVisor != null) ? c.ipVisor : location.hostname
            const visorPort = (c.portVisor != null) ? c.portVisor : location.port
            this._config.visorRoute = (`${visorProtocol}${visorHostname}${visorPort}/viewer/visor`);
            resolve(c);
            this.gettingConfig = false;
            switch (c.default_mode?.toLowerCase()) {
              case null:
              case 'patient':
              case 'paciente':
                this.permissionService.setBookMode('patient');
                break;
              case 'prescriber':
              case 'prescriptor':
              case 'medico':
              case 'médico':
                this.permissionService.setBookMode('prescriptor');
                break;
              default:
                this.permissionService.setBookMode('patient');
                break;
            }

            switch (c.tour_mode) {
              case 'none':
                this.tourService.setTourMode("none");
                break;
              case 'basic':
                this.tourService.setTourMode("basic");
                break;
              case 'cookies':
                this.tourService.setTourMode("cookies");
                break;
              case 'always':
                this.tourService.setTourMode("always");
                break;
              default:
                this.tourService.setTourMode("none");
                break;
            }

          });
        }
      }
    })
  }

  private getSystemConfig(): Promise<SystemConfig> {
    return new Promise<SystemConfig>((resolve, reject) => {
      this.BOOK_URL.then(BOOK_URL => {
        console.log('BOOK_URL', BOOK_URL);
        const url = BOOK_URL + '/bookAccess/getSystemConfig';
        this.http.get<SystemConfig>(url, { withCredentials: true, responseType: 'json' }).subscribe({
          next: res => resolve(res),
          error: err => reject(err)
        })
      });
    })

  }
}
